import { render, staticRenderFns } from "./PerformanceAuditReport.vue?vue&type=template&id=32fec2c6&scoped=true"
import script from "./PerformanceAuditReport.vue?vue&type=script&lang=js"
export * from "./PerformanceAuditReport.vue?vue&type=script&lang=js"
import style0 from "./PerformanceAuditReport.vue?vue&type=style&index=0&id=32fec2c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fec2c6",
  null
  
)

export default component.exports